import React from "react";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    return (
        <div className="-mt-2 flex justify-end items-center my-6 select-none w-full border-t pt-0">
            <div className="flex border border-gray-200 rounded-md bg-white shadow-sm overflow-hidden h-8">
                <button
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                    className={`px-3 text-[11px] font-medium border-r transition-colors
                     ${currentPage === 1
                            ? "text-gray-300 bg-gray-50"
                            : "text-gray-700 hover:bg-brand-primary hover:text-white"}`}
                >
                    Anterior
                </button>

                {[...Array(totalPages)].map((_, i) => {
                    const n = i + 1;
                    if (totalPages > 5 && Math.abs(n - currentPage) > 1 && n !== 1 && n !== totalPages) {
                        if (n === 2 || n === totalPages - 1)
                            return <span key={n} className="px-2 text-[11px] text-gray-400 border-r flex items-center bg-white">...</span>;
                        return null;
                    }
                    return (
                        <button
                            key={n}
                            onClick={() => onPageChange(n)}
                            className={`px-3 text-[11px] font-semibold border-r last:border-r-0 transition-colors
                                ${currentPage === n ? "bg-brand-primary text-white" : "text-gray-600 hover:bg-gray-100"}`}
                        >
                            {n}
                        </button>
                    );
                })}

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                    className={`px-3 text-[11px] font-medium border-r transition-colors
                      ${currentPage === totalPages
                            ? "text-gray-300 bg-gray-50"
                            : "text-gray-700 hover:bg-brand-primary hover:text-white"}`}
                >
                    Siguiente
                </button>
            </div>
        </div>
    );
}